import React from 'react';
import { motion } from 'framer-motion';
import ServiceCard from '../components/ServiceCard';
import { servicesData } from '../data/servicesData';

function Services() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  return (
    <section id="services" className="py-24 bg-slate-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* SEO: Header Section with Global Context */}
        <div className="text-center mb-20">
          <motion.span 
            initial={{ opacity: 0 }} 
            whileInView={{ opacity: 1 }} 
            className="text-blue-600 font-bold tracking-widest uppercase text-sm"
          >
            Worldwide Growth Solutions
          </motion.span>
          
          <motion.h2 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            className="text-4xl md:text-6xl font-black text-gray-900 mt-4 mb-6"
          >
            International <span className="text-blue-600">Standard</span> Services
          </motion.h2>
          
          <p className="max-w-2xl mx-auto text-gray-500 text-lg mb-8">
            Tailored digital strategies designed to help businesses scale across borders and dominate their industry globally.
          </p>
          <div className="w-24 h-1.5 bg-blue-600 mx-auto rounded-full"></div>
        </div>
        
        {/* Cards Grid */}
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10"
        >
          {servicesData.map((service) => (
            <ServiceCard 
              key={service.id} 
              id={service.id} 
              title={service.title} 
              desc={service.desc} 
              icon={service.icon} 
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Services;